import script from "./DialogBase.vue?vue&type=script&lang=ts&setup=true"
export * from "./DialogBase.vue?vue&type=script&lang=ts&setup=true"

import "./DialogBase.vue?vue&type=style&index=0&id=3b5985c4&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b5985c4"]])

export default __exports__